import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  jobs: { data: [], jobsLoadings: false },
  total_jobs_count: 0,
  appZoom: 1,
};

const NMjobsSlice = createSlice({
  name: "NMjobs",
  initialState,
  reducers: {
    jobsStart(state) {
      state.loading = true;
      state.jobs.jobsLoadings = true;
      state.error = null;
      // state.jobs.data = [];
    },
    jobsSuccess(state, action) {
      state.loading = false;
      state.jobs.jobsLoadings = false;


      state.jobs.data = action.payload.data || [];
      // Use totalCount from response if available (for candidate-specific queries)
      console.log("here is daata",state.jobs.data)
      if (action.payload.totalCount !== undefined) {
        state.total_jobs_count = action.payload.totalCount;
      }
    },
    jobsFailure(state, action) {
      state.loading = false;
      state.jobs.jobsLoadings = false;
      state.error = action.payload || "Failed to fetch Jobs Data";
    },
    clearJobs(state) {
      state.jobs = { data: [] };
      state.jobs.jobsLoadings = false;
      state.loading = false;
      state.error = null;
    },

    //jobs totla count
    fetchTotalJobsCountStart(state) {
      state.loading = true;
      // state.jobs.loading = true ;
      state.error = null;
    },

    fetchTotalJobsCountSuccess(state, action) {
      state.loading = false;
      state.total_jobs_count = action.payload.data || 0;
    },
    fetchTotalJobsCountFailure(state, action) {
      state.loading = false;
      state.error = action.payload || "Failed to fetch total count";
      state.total_jobs_count = action.payload || 0;
    },
    initAppZoom(state) {
      // handled by saga
    },
    setAppZoom(state, action) {
      state.appZoom = action.payload;
    },
  },
});

export const {
  jobsStart,
  jobsFailure,
  jobsSuccess,
  clearJobs,
  fetchTotalJobsCountFailure,
  fetchTotalJobsCountSuccess,
  fetchTotalJobsCountStart,
  initAppZoom,
  setAppZoom,
} = NMjobsSlice.actions;

export default NMjobsSlice.reducer;
